<template>
  <div class="grouping"
       :class="{ extended }">
    <div class="grouping-wrap">
      <div class="grouping-title">
        <div class="title-wrap">
          <span class="label">
            {{ $t('group.label') }}
          </span>
          <i class="setting icon icon--setting-size16"
            :class="{disabled: domain.shared === 'shared'}"
            @click="moveToSetting()"></i>
          <i :class="['expand', 'icon', `icon--arrow-${extended ? 'reduce' : 'expand'}`]"
             @click="onExpand()"></i>
        </div>

        <div class="group-options"
             :class="{ disabled: Object.keys(groupItems).length < 2 }"
             @mouseenter="resetDropdownTimer"
             @scroll.stop>
          <div class="selected"
               @click="openDropdown">
            <span class="label">
              {{ groupItems[group] }}
            </span>
            <i class="icon icon--arrow-updown"></i>
          </div>
          <div v-if="Object.keys(groupItems).length > 1"
               class="item-list"
               @mouseleave="startDropdownTimer"
               :class="{ active: dropdownOpen }">
            <div class="item-list-wrap">
              <button class="item-list-item"
                      v-for="[val, key] in Object.entries(groupItems)"
                      :key="`domain${val}`"
                      :class="{ active: val === group }"
                      @click="onGroupChange(val)">
                <span class="label">{{ key }}</span>
                <i v-if="group === val"
                   class="icon icon--check-green-size16"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="grouping-list">
        <ul>
          <li v-for="tag in listData"
              :key="`tag-item-${tag.tagId}`">
            <template v-if="tag.tagId < 0">
              <span class="tag-bullet">
                <span></span>
              </span><span class="tag-name">
                <div class="tag upcoming">{{ $t('group.upcoming') }}</div>
              </span>
            </template>
            <template v-else>
              <span class="tag-bullet">
                <span :style="{ background: tag.colorHex }"></span>
              </span><span class="tag-name">
                <div class="tag">{{ tag.tagName | onlySubdomain(journeyOptions.domain) }}</div>
              </span>
            </template>
          </li>
        </ul>
      </div>
      <div class="grouping-navigation">
        <ui-navigation :currentPage="listOption.pageNum"
                       :lastPage="lastPage"
                       :itemsPerPage="listOption.itemsPerPage"
                       @setPage="setPage" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/libs/event-bus'

import { getTagList, getGroupStat } from '@/api/group'

import UiNavigation from '@/components/ui/UiNavigation'

export default {
  name: 'grouping',
  components: {
    UiNavigation
  },
  props: ['group', 'domain', 'groupItems'],
  computed: {
    ...mapState([
      'journeyOptions'
    ]),
    sid () {
      return this.$route.query.sid
    }
  },
  created () {
    this.listOption = {
      pageNum: 1,
      itemsPerPage: 50,
      sort: 'tagName'
    }
    this.loadGroupStat()
    this.loadTagList()
  },
  watch: {
    group () {
      this.listOption = {
        pageNum: 1,
        itemsPerPage: 50,
        sort: 'tagName'
      }
      this.loadGroupStat()
      this.loadTagList()
    }
  },
  methods: {
    loadGroupStat () {
      return new Promise(resolve => {
        getGroupStat({
          sid: this.sid,
          groupId: this.group
        }, true).then(result => {
          this.lastPage = Math.ceil(result.tags / this.listOption.itemsPerPage)
          resolve()
        })
      })
    },
    loadTagList () {
      return new Promise(resolve => {
        getTagList({
          sid: this.sid,
          pageId: this.listOption.pageNum - 1,
          pageNum: this.listOption.itemsPerPage,
          sort: this.listOption.sort,
          groupId: this.group
        }, true).then(result => {
          this.listData = []
          for (let tag of result) {
            this.listData.push({
              tagId: tag.tagId,
              colorHex: tag.colorHex,
              tagName: tag.tagName,
              numOfUrl: tag.numOfUrl,
              recentUrlCount: tag.recentUrlCount || 0
            })
          }
          resolve()
        })
      })
    },
    moveToSetting () {
      EventBus.$emit('settingGroup')
    },
    onExpand () {
      this.extended = !this.extended
    },
    onGroupChange (value) {
      this.dropdownOpen = false
      this.resetDropdownTimer()
      this.$emit('onGroupChange', value)
    },
    startDropdownTimer: function () {
      this.dropdownTimer = setInterval(() => {
        if (this.dropdownTimerTime < 3) {
          this.dropdownOpen = false
        }
        this.dropdownTimerTime--
      }, 1000)
    },
    resetDropdownTimer: function () {
      this.dropdownTimerTime = 3
      clearInterval(this.dropdownTimer)
      this.dropdownTimer = null
    },
    openDropdown () {
      this.dropdownOpen = true
      this.resetDropdownTimer()
    },
    setPage (page) {
      this.listOption.pageNum = page
      this.loadTagList()
    }
  },
  data () {
    return {
      dropdownOpen: false,
      dropdownTimerTime: null,

      extended: true,

      listData: [],

      listOption: {
        pageNum: 1,
        itemsPerPage: 50,
        sort: 'tagName'
      },

      lastPage: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.grouping {
  position: relative;
  width: 230px;
  height: 47px;
  border-radius: 10px;
  box-shadow: 0 21px 40px -10px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  overflow: hidden;
  transition: height 0.3s ease;
  -webkit-transform: translate3d(0,0,0);
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;

  &.extended {
    height: 460px;

    .grouping-title {
      .title-wrap {
        .icon {
          &.expand {
            top: 8px;
            right: 8px;
          }
        }
        .setting {
          &.disabled {
            pointer-events: none;
            opacity: .3;
          }
        }
      }

      .group-options {
        margin-top: 0;
      }
    }
  }

  .grouping-title {
    height: 88px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);

    .title-wrap {
      padding: 15px;

      .label {
        vertical-align: middle;
        font-size: 14px;
        font-weight: 500;
        line-height: 1;
        color: #444;
      }

      .icon {
        vertical-align: middle;
        cursor: pointer;
        padding: 3px;
        margin: -3px;
        background-size: 13px 13px;

        &.icon--setting-size16 {
          border-radius: 20px;
          background-size: 16px 16px;
          transition: background-color 0.2s ease;

          &:hover {
            background-color: rgba(0, 0, 0, 0.06);
          }
        }

        &.expand {
          position: absolute;
          top: 16px;
          right: 16px;
          transition: top 0.3s ease,
                      right 0.3s ease;
        }
      }
    }

    .group-options {
      position: relative;
      z-index: 5;
      display: inline-block;
      vertical-align: middle;
      width: 200px;
      margin: 2px 15px 0 15px;
      text-align: left;

      &.disabled {
        .selected {
          opacity: 0.3;
          cursor: default;
        }
      }

      .selected {
        border-radius: 5px;
        border: solid 1px #e0e0e0;
        background-color: #ffffff;
        height: 16px;
        padding: 7px 30px 7px 10px;
        cursor: pointer;
        line-height: 16px;

        .label {
          display: inline-block;
          vertical-align: middle;
          height: 16px;
          font-size: 13px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #2f2f2f;
        }

        .icon {
          position: absolute;
          top: calc(50% - 9px);
          right: 3px;
          vertical-align: middle;
          margin-top: 1px;
          margin-right: 6px;
        }
      }

      .item-list {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        overflow: hidden;
        border-radius: 6px;
        box-shadow: 0 12px 15px -6px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(0, 0, 0, 0.06);
        background-color: #ffffff;
        color: #444444;
        transform-origin: top;
        transform: scaleY(0);
        opacity: 0;
        transition: transform 0.3s ease,
                    opacity 0.2s ease;

        &.active {
          transform: scaleY(1);
          opacity: 1;
        }

        .item-list-wrap {
          max-height: 370px;
          overflow-y: auto;
        }

        .item-list-item {
          position: relative;
          width: 100%;
          height: 30px;
          background-color: #ffffff;
          transition: background-color 0.2s ease;
          text-align: left;
          font-size: 12px;
          color: #2f2f2f;

          .label {
            display: inline-block;
            width: calc(100% - 20px);
            padding: 0 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            vertical-align: middle;
          }

          .icon {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
          }

          &:hover {
            background-color: #ebebeb;
          }

          &:first-child {
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }

          &:last-child {
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
          }
        }
      }
    }
  }

  .grouping-list {
    height: 318px;
    overflow: auto;

    ul {
      padding: 12px 16px;

      li {
        padding: 6px 0;

        .tag-bullet {
          display: inline-block;
          vertical-align: top;
          width: 12px;
          height: 12px;
          margin-right: 5px;

          span {
            display: block;
            width: 12px;
            height: 12px;
            border-radius: 12px;
            background-color: #bbbbbb;
            border: 1px solid rgba(0, 0, 0, 0.05);
          }

          .icon {
            vertical-align: middle;
          }
        }

        .tag-name {
          width: calc(100% - 25px);
          padding-left: 4px;
          display: inline-block;
          vertical-align: top;
          font-size: 12px;
          line-height: 1.33;
          color: #777;
          word-break: break-all;

          .tag {

            &.upcoming {
              font-weight: bold;
              color: #444;
            }
          }
        }
      }
    }
  }

  .grouping-navigation {
    text-align: center;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
  }
}
</style>
